export const seoData = {
  '/': {
    'title': 'Cloud Solutions',
    'description': 'Your Gateway to Scalable OpenStack Cloud Solution and Automatization.',
  },
  '/products/openstack-solution-kit': {
    'title': 'OpenStack Solution Kit',
    'description': 'Effortlessly manage your OpenStack Cloud infrastructure with the OpenStack Admin & Customer UIs and take charge of your Cloud\'s billing and pricing with Billing System.',
  },
  '/products/isender': {
    'title': 'iSender Application',
    'description': 'Automate your invoicing and notifications, design and personalize templates with Ease, embed iSender into your web application.',
  },
}